import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PlatformRootComponent} from './platform-root/platform-root.component';
import {Route} from '../enum/route';
import {AuthGuard} from '../services/auth-guard/auth.guard.service';
import {Roles} from '../enum/roles';

//website-pages imports
import {StartPageComponent} from './website-pages/start-page/start-page.component';
import {ImprintPageComponent} from './website-pages/imprint-page/imprint-page.component';
import {DataProtectionPageComponent} from './website-pages/data-protection-page/data-protection-page.component';
import {ContactPageComponent} from './website-pages/contact-page/contact-page.component';
import {DownloadPageComponent} from './website-pages/download-page/download-page.component';
import {TutorialPageComponent} from './website-pages/tutorial-page/tutorial-page.component';
import {AboutPageComponent} from './website-pages/about-page/about-page.component';
import {EventPageComponent} from './website-pages/event-page/event-page.component';

import {ProposalOverviewComponent} from './proposal-overview/proposal-overview.component';
import {CreateProposalComponent} from './create-proposal/create-proposal.component';
import {ProfileUserComponent} from './profile-user/profile-user.component';
import {OnboardingUserComponent} from './onboarding-user/onboarding-user.component';
import {AccountComponent} from './account/account.component';
import {HelpComponent} from './help/help.component';
import {ProposalDetailsComponent} from './proposal-detail/proposal-details.component';
import {OnboardingCompanyComponent} from './onboarding-company/onboarding-company.component';
import {ProfileCompanyComponent} from './profile-company/profile-company.component';

import {CreateOfferComponent} from './create-offer/create-offer.component';
import {CreateExternalCoverageComponent} from './create-external-coverage/create-external-coverage.component';
import {ProposalPreviewPageComponent} from './proposal-preview-page/proposal-preview-page.component';
import {BillBoardComponent} from './bill-board/bill-board.component';
import {MemberOverviewComponent} from './member-overview/member-overview.component';
import {MailingsComponent} from './mailings/mailings.component';
import {OfferPreviewPageComponent} from './offer-preview-page/offer-preview-page.component';
import {ErrorRoleComponent} from './error-role/error-role.component';

export const routes: Routes = [
  {
    path: Route.HOME,
    component: StartPageComponent,
  },
  {
    path: Route.ABOUT,
    component: AboutPageComponent,
  },
  {
    path: Route.IMPRINT,
    component: ImprintPageComponent,
  },
  {
    path: Route.EVENT,
    component: EventPageComponent,
  },
  {
    path: Route.DATAPROTECTION,
    component: DataProtectionPageComponent,
  },
  {
    path: Route.DOWNLOADS,
    component: DownloadPageComponent,
  },
  {
    path: Route.ONBOARDING_CA,
    component: TutorialPageComponent,
  },
  {
    path: Route.ONBOARDING,
    component: TutorialPageComponent,
  },
  {
    path: Route.SHOWCASE,
    component: TutorialPageComponent,
  },
  {
    path: Route.TUTORIAL,
    component: TutorialPageComponent,
  },
  {
    path: Route.CONTACT,
    component: ContactPageComponent,
  },
  {
    path: Route.ERROR_ROLE,
    component: ErrorRoleComponent,
  },
  {
    path: Route.CREATE_USER,
    component: OnboardingUserComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Roles.ROLE_INSURER,
        Roles.ROLE_INSURANCE_AGENT,
        Roles.ROLE_INSURANCE_ADVISOR,
        Roles.ROLE_ADJUSTER,
        Roles.ROLE_UNDERWRITER,
        Roles.ROLE_CORPORATE_ADMIN,
        Roles.ROLE_BROKER,
        Roles.ROLE_REPRESENTATIVE,
        Roles.ROLE_ASSOCIATION_ADMIN,
        Roles.ROLE_EXPERT
      ],
    }
  },
  {
    path: Route.CREATE_COMPANY,
    component: OnboardingCompanyComponent,
  },
  {
    path: '',
    component: PlatformRootComponent,
    children: [
      {
        path: Route.INSERATE,
        component: ProposalOverviewComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURER,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_BUSINESS_ADMIN
          ],
        }
      },
      {
        path: Route.INSERAT_ERSTELLEN,
        component: CreateProposalComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURER,
            Roles.ROLE_UNDERWRITER
          ],
        }
      },
      {
        path: Route.PROPOSAL_DETAILS + '/:id',
        component: ProposalDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER
          ],
        }
      },
      {
        path: Route.CREATE_OFFER + '/:id',
        component: CreateOfferComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER
          ],
        }
      },
      {
        path: Route.CREATE_EXTERNAL_COVERAGE + '/:id',
        component: CreateExternalCoverageComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER
          ],
        }
      },
      {
        path: Route.USER_PAGE + '/:id',
        component: ProfileUserComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_REPRESENTATIVE,
            Roles.ROLE_EXPERT
          ],
        }
      },
      {
        path: Route.COMPANY_PROFILE + '/:id',
        component: ProfileCompanyComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_REPRESENTATIVE,
            Roles.ROLE_EXPERT
          ],
        }
      },
      {
        path: Route.ACCOUNT + '/:id',
        component: AccountComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_CORPORATE_ADMIN,
            Roles.ROLE_DIRECT_CORPORATE_ADMIN,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_REPRESENTATIVE,
            Roles.ROLE_ASSOCIATION_ADMIN,
            Roles.ROLE_EXPERT
          ],
        }
      },
      {
        path: Route.HELP,
        component: HelpComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_ADMIN,
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_CORPORATE_ADMIN,
            Roles.ROLE_DIRECT_CORPORATE_ADMIN,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_ASSOCIATION_ADMIN,
            Roles.ROLE_EXPERT
          ],
        }
      },
      {
        path: Route.BILL_BOARD,
        component: BillBoardComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_CORPORATE_ADMIN,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_REPRESENTATIVE,
            Roles.ROLE_ASSOCIATION_ADMIN,
            Roles.ROLE_EXPERT,
            Roles.ROLE_BROKER,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_INSURER
          ],
        }
      },
      {
        path: Route.MAILINGS,
        component: MailingsComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_ADMIN,
            Roles.ROLE_ASSOCIATION_ADMIN
          ]
        }
      },
      {
        path: Route.MEMBER_OVERVIEW,
        component: MemberOverviewComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_CORPORATE_ADMIN,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_REPRESENTATIVE,
            Roles.ROLE_ASSOCIATION_ADMIN,
            Roles.ROLE_EXPERT,
            Roles.ROLE_BROKER,
            Roles.ROLE_UNDERWRITER,
            Roles.ROLE_INSURER
          ],
        }
      },
      {
        path: Route.INSERAT_ERSTELLEN + '/' + Route.PROPOSAL_PREVIEW,
        component: ProposalPreviewPageComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER
          ],
        }
      },
      {
        path: Route.INSERAT_ERSTELLEN + '/' + Route.PROPOSAL_PREVIEW + '/:id',
        component: ProposalPreviewPageComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURER
          ],
        }
      },
      {
        path: Route.OFFER_PREVIEW,
        component: OfferPreviewPageComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Roles.ROLE_INSURER,
            Roles.ROLE_BROKER,
            Roles.ROLE_INSURANCE_AGENT,
            Roles.ROLE_INSURANCE_ADVISOR,
            Roles.ROLE_ADJUSTER,
            Roles.ROLE_UNDERWRITER
          ],
        }
      },
    ]
  },
  {
    path: Route.INSERAT_ERSTELLEN + '/:id',
    component: CreateProposalComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Roles.ROLE_BROKER,
        Roles.ROLE_INSURER
      ],
    }
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes)
  ]
})
export class PagesRoutingModule {
}

